import AppContext from "PFApp/app_context";
import PageBox from "PFComponents/box/page_box";
import { Button } from "PFComponents/button";
import ButtonLink from "PFComponents/button/button_link";
import DataTable from "PFComponents/data_table/data_table";
import SimplePagination from "PFComponents/pagination/simple_pagination";
import { useDateFormatter } from "PFCore/hooks/use_date_formatter";
import { ApiRoute } from "PFCore/utilities/routes";
import { GROWL_ACTIONS } from "PFReducers/growl_reducer";
import PropTypes from "prop-types";
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";

import css from "./change_request_list_page.module.scss";

const ChangeRequestsListPage = ({ ChangeRequestCollection, fetchChangeRequests, profileId }) => {
  const { t } = useTranslation("admin");
  const { dispatch } = useContext(AppContext);
  const { entries, meta } = ChangeRequestCollection;
  const { formatDateTime } = useDateFormatter();

  const handleRemoveChangeRequest = (item) => {
    if (confirm(t("changeRequests.sureToDelete"))) {
      $.ajax({
        url: ApiRoute(`/api/change_requests/${item?.id}`),
        method: "DELETE",
        api_version: 2
      })
        .then((resp) => {
          fetchChangeRequests(1, 10, profileId);
          dispatch({
            type: GROWL_ACTIONS.GROWL_RENDER,
            payload: {
              message: resp?.message,
              kind: "success"
            }
          });
        })
        .catch((err) =>
          dispatch({
            type: GROWL_ACTIONS.GROWL_RENDER,
            payload: {
              message: err?.message,
              kind: "error"
            }
          })
        );
    }
  };

  const renderActions = (item) => (
    <div className={css.buttons}>
      <ButtonLink kind="secondary" small href={`/admin/change_requests/${item?.data?.id}/${item?.id}`}>
        {t("changeRequests.details")}
      </ButtonLink>
      <Button kind="danger" small onClick={() => handleRemoveChangeRequest(item)}>
        {t("changeRequests.remove")}
      </Button>
    </div>
  );

  const cellRenderer = (attribute) => <span>{attribute}</span>;

  return (
    <>
      <div className={css.header}>
        <h1>{t("changeRequests.forUser")}</h1>
        <div>{`${t("changeRequests.totalCount")} ${meta?.total}`}</div>
      </div>
      <PageBox style={{ maxWidth: 800 }}>
        {meta?.total > 0 ? (
          <DataTable
            style={{ whiteSpace: "nowrap" }}
            columns={[
              {
                headerName: "Source",
                renderCell: (data) => cellRenderer(data.source_display_as)
              },
              {
                headerName: "Created at",
                renderCell: (data) => cellRenderer(formatDateTime(data.created_at))
              },
              {
                headerName: "Actions",
                renderCell: (data) => renderActions(data),
                narrow: true
              }
            ]}
            data={entries}
          />
        ) : (
          <div className={css.noDataText}>{t("changeRequests.empty")}</div>
        )}
      </PageBox>
      <div style={{ marginTop: "30px" }}>
        <SimplePagination
          currentPage={meta?.page}
          totalPages={meta?.totalPages}
          handleClick={fetchChangeRequests}
        />
      </div>
    </>
  );
};

ChangeRequestsListPage.propTypes = {
  ChangeRequestCollection: PropTypes.PropTypes.shape({
    entries: PropTypes.arrayOf(
      PropTypes.shape({
        source: PropTypes.string,
        created_at: PropTypes.string
      })
    ).isRequired,
    meta: PropTypes.shape({
      total: PropTypes.number,
      page: PropTypes.number,
      totalPages: PropTypes.number
    })
  }),
  fetchChangeRequests: PropTypes.func,
  profileId: PropTypes.number
};

export default ChangeRequestsListPage;
